import React from 'react'
import "../Styles/PrivacyPage.css"

function PrivacyPage() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy for BeRealTimelapse</h1>
      <p2><strong>Effective Date:</strong> 12/30/2024</p2>
      <br></br>

      <p2>
        BeRealTimelapse (“we,” “our,” or “us”) values your privacy and is
        committed to protecting your personal information. This Privacy Policy
        outlines how we collect, use, and safeguard the data you provide when
        using our web application to create timelapse videos from your BeReal
        photos. By using our service, you agree to the terms outlined in this
        Privacy Policy.
      </p2>

      <h2>1. Data We Collect</h2>
      <p2>
        When you use BeRealTimelapse, we collect the following information:
      </p2>
      <ul>
        <li>
          <strong>Photos and Metadata:</strong> You upload BeReal photos and associated
          metadata (e.g., the `posts.json` file) to generate your timelapse.
        </li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <p2>We use the data you provide for the sole purpose of creating and delivering your timelapse:</p2>
      <ul>
        <li>
          <strong>Photos and Metadata:</strong> Used exclusively to generate your timelapse video.
        </li>
      </ul>

      <h2>3. Data Retention and Deletion</h2>
      <ul>
        <li>
          <strong>Temporary Storage:</strong> Your photos, metadata, and completed timelapse
          video are stored temporarily on our servers during processing.
        </li>
        <li>
          <strong>Deletion:</strong> All uploaded data and generated timelapse videos will be
          deleted from our servers after you download the final product, or within 7 days of creation if not downloaded.
        </li>
      </ul>

      <h2>4. Data Sharing</h2>
      <p2>
        We do not share, sell, or disclose your personal information, photos, metadata,
        or timelapse videos to any third parties.
      </p2>

      <h2>5. Security</h2>
      <p2>
        We implement industry-standard security measures to protect your data from
        unauthorized access, alteration, disclosure, or destruction. However, no
        method of transmission over the internet or electronic storage is 100%
        secure, and we cannot guarantee absolute security.
      </p2>

      <h2>6. Your Rights</h2>
      <ul>
        <li>
          <strong>Access and Deletion:</strong> You can request access to or deletion of
          your data at any time by contacting us at contact@berealtimelapse.com.
        </li>
        <li>
          <strong>Consent Withdrawal:</strong> You may withdraw your consent at any time, but this may prevent us from delivering your timelapse.
        </li>
      </ul>

      <h2>7. Third-Party Services</h2>
      <p2>
        BeRealTimelapse is not affiliated with or endorsed by BeReal. Users are solely
        responsible for complying with BeReal’s terms of service and privacy
        policies when exporting and uploading data to BeRealTimelapse.
      </p2>

      <h2>8. Updates to This Privacy Policy</h2>
      <p2>
        We may update this Privacy Policy from time to time to reflect changes in
        our practices or applicable laws. The effective date at the top of this
        document indicates when the policy was last updated.
      </p2>

      <h2>9. Contact Us</h2>
      <p2>
        If you have questions or concerns about this Privacy Policy or our data practices, please contact us at:
      </p2>
      <p2><strong> contact@berealtimelapse.com</strong></p2>
    </div>
  )
}

export default PrivacyPage;
